import { Component, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'manager-groups',
  template: `
    <table>
      <tr *ngFor="let group of groups">
        <td>{{ group }}</td>
      </tr>
    </table>
  `,
  styles: [
    `
      td {
        border: 1px;
      }
    `,
  ],
})
export class ManagerGroupComponent implements OnDestroy, AgRendererComponent {
  groups: any;

  constructor(public cService: CommonService) {
    this.groups = [];
  }

  agInit(params: any): void {
    if (params.data.manages) {
      if (params.data.manages.length > 1) {
      }
      this.groups = params.data.manages;
    }
  }

  ngOnDestroy() {}

  refresh(params: any): boolean {
    return false;
  }
}
